export default __webpack_public_path__ + "static/media/ic_marker.82a8a6f9.svg";